// extracted by mini-css-extract-plugin
export default {"container":"PositionSkill_container__xGE0p","icon":"PositionSkill_icon__-SnfD"};